// F1 (Mohammed 30/09): a view field marked alwaysShow (db_view_fields.always_show, e.g. the enquiry Status) is on
// the grid whatever the user's saved column choice: it keeps its place when chosen, else it is added last.

export function withAlwaysShown(chosen, viewFields) {
  var out = (chosen || []).slice()
  ;(viewFields || []).forEach(f => {
    if (f && f.alwaysShow && f.canShow !== false && !out.some(c => c && c.dbField === f.dbField)) out.push(f)
  })
  return out
}
